import { render, staticRenderFns } from "./PrestationsCartesCadeaux.vue?vue&type=template&id=044979f6&"
import script from "./PrestationsCartesCadeaux.vue?vue&type=script&lang=js&"
export * from "./PrestationsCartesCadeaux.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports